import { createContext, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from '@febos-io/auth';
import { providers } from '@febos-io/design';

import { useConfigsByParameter } from '../hooks/useConfigsByParameter';
import settingLevel from '../config/settingLevel';
import { getSettings, setConfigurations } from '../store';

export const ConfigurationsProvider = ({
  parametersIds,
  children
}: {
  parametersIds: string[];
  children: React.ReactNode;
}) => {
  const dispatch = useDispatch();
  const { Loader } = providers.useDesignContext();
  const companyId = useSelector(store.getCompanyId);
  const configurations:object = useSelector(getSettings);
  const { loading, element: setting } = useConfigsByParameter({
    companyId: companyId,
    parameters: parametersIds,
    reference: undefined,
    maxLevel: settingLevel.COMPANY
  });
  useEffect(() => {
    dispatch(
      setConfigurations({
        companyId,
        configurations: setting
      })
    );
  }, [setting]);
  const isLoading = useMemo(() => {
    // revisar si todos los parametros estan cargados en settings
    if (loading && parametersIds.some((parameter) => !configurations[parameter])) {
      return true;
    }
    return false;
  }, [configurations, loading, parametersIds]);
  return (
    <ConfigurationsContext.Provider
      value={{
        configurations: configurations,
        loading: isLoading
      }}
    >
      {isLoading ? <Loader /> : children}
    </ConfigurationsContext.Provider>
  );
};
// Crea un contexto para la información del pre-order
export const ConfigurationsContext = createContext({
  configurations: {},
  loading: false
});

export const useConfigurationsContext = () => useContext(ConfigurationsContext);

export default ConfigurationsContext;
